// extracted by mini-css-extract-plugin
export var background = "ProducerListCard-module--background--IQ97X";
export var logo = "ProducerListCard-module--logo--m+2Np";
export var title = "ProducerListCard-module--title--zDUdV";
export var wrapper = "ProducerListCard-module--wrapper--7wJqM";